'use client'

import { Dialog, DialogContent, styled } from '@mui/material'

export const WelcomeDialogueStyle = styled(Dialog)(({ theme }) => ({
  maxWidth: theme.customDimensions.welcomeDialogMobile,
  margin: 'auto auto',
  '.MuiBackdrop-root': {
    backgroundColor: theme.palette.background.carouselButton,
  },
  [theme.breakpoints.up('md')]: {
    maxWidth: theme.customDimensions.welcomeDialog,
  },
}))
export const WelcomeDialogContent = styled(DialogContent)(() => ({
  textAlign: 'center',
  margin: 0,
  paddingInline: 30,
  paddingTop: 14,
  paddingBottom: 24,
}))
